import { Checkbox, CheckboxGroup } from '@policygenius/mortar';
import classnames from 'classnames';
import React from 'react';
import { useField, useFormState } from 'react-final-form';

import { FieldRenderProps } from 'forms/types';
import getErrorMessage from 'forms/utils/getErrorMessage';

import formStyles from '../form-inputs.module.scss';
import styles from './checkbox-list.module.scss';
import { CheckboxListProps } from './types';

type Props = CheckboxListProps & FieldRenderProps<unknown>;

const CheckboxList = ({ input, meta, options, ...props }: Props) => {
  const { initialValues } = useFormState();

  return (
    <div className={formStyles['field-container']}>
      <CheckboxGroup
        {...props}
        errorMessage={getErrorMessage(meta)}
        name={input.name}
        showGroupLabel
      >
        {options.map((option) => {
          // Mortar only allows its Checkbox as a child component, so we need to call `useField` within this callback
          // eslint-disable-next-line react-hooks/rules-of-hooks
          const checkbox = useField<boolean, HTMLInputElement>(option.name, {
            type: 'checkbox',
            initialValue: initialValues[option.name] ?? false,
          });

          return (
            <Checkbox
              key={option.name}
              {...checkbox.input}
              className={classnames(option.footer && styles.footer)}
              label={option.label}
              value={option.name}
              onBlur={(e) => {
                checkbox.input.onBlur(e);
                input.onBlur(e);
              }}
              onChange={(e) => {
                const newVal = e.target.checked;

                option.onChange?.(newVal);
                checkbox.input.onChange(newVal);
              }}
              onFocus={(e) => {
                checkbox.input.onFocus(e);
                input.onFocus(e);
              }}
            />
          );
        })}
      </CheckboxGroup>
    </div>
  );
};

export default CheckboxList;
